import { render } from "./ScriptPrePrintDetailed.vue?vue&type=template&id=2c4e31df&scoped=true"
import script from "./ScriptPrePrintDetailed.vue?vue&type=script&lang=js"
export * from "./ScriptPrePrintDetailed.vue?vue&type=script&lang=js"

import "./ScriptPrePrintDetailed.vue?vue&type=style&index=0&id=2c4e31df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4e31df"]])

export default __exports__